export default __webpack_public_path__ + "static/media/private-scrollover.a006af5f.jpg";